<template>
    <div class="html-template">
        <div>
            <p>Html Template Example</p>
            <p>{{mapTitle}}</p>
        </div>
    </div>
</template>

<script>
    import HtmlTemplateModule from '../store-mixin'

    export default {
        name: 'HtmlTemplate',
        mixins: [HtmlTemplateModule()],
    }
</script>


<style lang="scss">

    .html-template{
        background: white;
        display: block;

        justify-content: space-between;
        height: 100%;

        div {

            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: center;

            p {
                font-size: 60px;
                transform: rotate(45deg);
                transform-origin: center;
                text-align: center;

            }
        }

    }
</style>

